import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useMediaStore } from "../store";
import { getAllMediaSource } from "../api/getMediaDataForPlans";

const ProtectedRoute = ({ element: Element }) => {
  const getCookie = (name) => {
    const cookieStr = document.cookie;
    const cookies = cookieStr.split("; ");

    for (let cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return decodeURIComponent(value);
    }

    return null;
  };

  const isAuthenticated = getCookie("accessToken");

  const { setImageUrls, setVideoUrls, setLoading } = useMediaStore();
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    const fetchMediaData = async () => {
      try {
        setLocalLoading(true);
        setLoading(true);

        const bannerData = await getAllMediaSource("banner");
        const videoData = await getAllMediaSource("video");

        setImageUrls(
          bannerData.map((item) => ({
            label: item?.fileName,
            value: item.cdnUrl,
          }))
        );
        setVideoUrls(
          videoData.map((item) => ({
            label: item?.fileName,
            value: item.cdnUrl,
          }))
        );

        setLocalLoading(false);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching media data:", error);
        setLocalLoading(false);
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchMediaData();
    }
  }, [isAuthenticated, setImageUrls, setVideoUrls, setLoading]);

  return isAuthenticated ? <Element /> : <Navigate to="/" />;
};

export default ProtectedRoute;